import axiosClient from "./axiosClient";

const serviceUrl = "/qlkhambenh";

const examOutService = {
  updateTrangThaiKBNT: async (params) => {
    const url =
      serviceUrl +
      `/phieu-kham-ngoai-tru/cap-nhat-trang-thai?id=${params.id}&trangThai=${params.trangThai}&bacSyKham=${params.bacSyKham}`;
    const response = await axiosClient.put(url);
    return response.data;
  },
  getHistoriesByIdPK: async (params) => {
    const url = serviceUrl + `/lich-su-kham-benh`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDonKinhByIdPK: async (params) => {
    const url = serviceUrl + `/refraction/glasses_prescription`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getPhieuKhamIn: async (params) => {
    const url = serviceUrl + `/phieu-kham-ngoai-tru-in`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  searchDMDichVu: async (params) => {
    const url = serviceUrl + `/dm-dich-vu/search-dm-dich-vu`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDataReportKB: async (params) => {
    const url = `/qlkhambenh/phieu-kham/bao-cao-thoi-gian-cho`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getLisDoctor: async () => {

    const url = `/hanhchinhnhansu/nhan-vien/danh-sach-bac-si`;
    const response = await axiosClient.get(url, {
      params: {
        page: 1,
        limit: 100
      }
    });
    return response.data;
  },

  getDataReportRevenueKB: async (params) => {
    const url = `/qlkhambenh/bao-cao-tong-hop/doanh-thu-theo-bac-sy`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDonThuocCu: async (idPhieuKham) => {
    const url = `/qlkhambenh/phieu-kham-ngoai-tru/don-thuoc-gan-nhat?idPhieuKhamNgoaiTru=${idPhieuKham}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getLichSuDonThuoc: async (idPhieuKham) => {
    const url = `/qlkhambenh/phieu-kham-ngoai-tru/lich-su-don-thuoc?idPhieuKhamNgoaiTru=${idPhieuKham}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
};

export default examOutService;
